import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1482.42 L1920,1602.42 L0,1602.42 L0,1482.42 L1920,1482.42 Z M1920,1122.42 L1920,1242.42 L0,1242.42 L0,1122.42 L1920,1122.42 Z M1920,762.42 L1920,882.42 L840,882.42 L840,762.42 L1920,762.42 Z M462.456,300.048 L744.936,582.528 L462.456,864.888 L377.616,780.048 L515.136,642.408 L-0.024,642.408 L-0.024,522.408 L515.136,522.408 L377.616,384.768 L462.456,300.048 Z M1920,402.42 L1920,522.42 L840,522.42 L840,402.42 L1920,402.42 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconIndentLine = /*#__PURE__*/function (_Component) {
  _inherits(IconIndentLine, _Component);

  var _super = _createSuper(IconIndentLine);

  function IconIndentLine() {
    _classCallCheck(this, IconIndentLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconIndentLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconIndent",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconIndentLine.displayName = "IconIndentLine";
  return IconIndentLine;
}(Component);

IconIndentLine.glyphName = 'indent';
IconIndentLine.variant = 'Line';
IconIndentLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconIndentLine;
export { IconIndentLine };